import React from "react";
import SbEditable from "storyblok-react";
import RichText from "src/utils/RichText";
import Heading from "src/components/Heading.js";

const Addresses = (item) => {
  return (
    <>
      {item.location.map((item) => (
        <SbEditable content={item} key={item._uid}>
          <div className="block pb-12">
            <Heading size="h5" className="text-darkgrey">
              {item.title}
            </Heading>
            <div className="mt-2 text-sm h-20">
              <RichText>{item.address}</RichText>
            </div>
            <p className="mt-2 text-sm">
              <span className="block">T: {item.telephone}</span>
              <span className="block">
                E:{" "}
                <a
                  className="transition duration-300 text-red lg:text-darkgrey hover:text-red"
                  href={`mailto:${item.email}`}
                >
                  {item.email}
                </a>
              </span>
            </p>
          </div>
        </SbEditable>
      ))}
    </>
  );
};

export default Addresses;
